import React, { createContext, useContext, useReducer } from 'react';

const QuoteContext = createContext();

const quoteReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TO_QUOTE':
      const existingIndex = state.items.findIndex(item => item.productId === action.payload.productId);
      if (existingIndex >= 0) {
        const updatedItems = [...state.items];
        updatedItems[existingIndex] = {
          ...updatedItems[existingIndex],
          quantity: action.payload.quantity,
          notes: action.payload.notes
        };
        return { ...state, items: updatedItems };
      }
      return { ...state, items: [...state.items, action.payload] };
    
    case 'REMOVE_FROM_QUOTE':
      return {
        ...state,
        items: state.items.filter(item => item.productId !== action.payload)
      };
    
    case 'CLEAR_QUOTE':
      return { ...state, items: [] };
    
    default:
      return state;
  }
};

export const QuoteProvider = ({ children }) => {
  const [state, dispatch] = useReducer(quoteReducer, { items: [] });

  const addToQuote = (item) => {
    dispatch({ type: 'ADD_TO_QUOTE', payload: item });
  };

  const removeFromQuote = (productId) => {
    dispatch({ type: 'REMOVE_FROM_QUOTE', payload: productId });
  };

  const clearQuote = () => {
    dispatch({ type: 'CLEAR_QUOTE' });
  };

  return (
    <QuoteContext.Provider value={{
      quoteItems: state.items,
      addToQuote,
      removeFromQuote,
      clearQuote
    }}>
      {children}
    </QuoteContext.Provider>
  );
};

export const useQuote = () => {
  const context = useContext(QuoteContext);
  if (!context) {
    throw new Error('useQuote must be used within a QuoteProvider');
  }
  return context;
};
